<template>
  <tr>
    <td class="name">{{manager.name}}</td>
    <td class="email">{{manager.email}}</td>
    <td class="actions">
      <b-button variant="outline-success" @click="$emit('addManager', manager)"><i class="fa fa-user-plus"></i> Add</b-button>
    </td>
  </tr>
</template>

<script>
export default {
  name: 'ManagerItemAdd',
  props: ['manager']
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
